/**
 *  Normalizes an error message key by replacing all
 *  whitespaces with dashes.
 */
export const normalizeErrorMessageKey = (msgKey) => {
  return `${msgKey}`;
};

/**
 *  Error reasons map contains all error messages
 *  that will be mapped from their original message
 *  to their respective translation key.
 */
export const ErrorReasons = {
  connectionRefused: 'app.error.network.connectionRefused',
  badRequest: 'app.error.badRequest',
  unauthorized: 'app.error.unauthorized',
  forbidden: 'app.error.forbidden',
  internalError: 'app.error.internalError',
  'file-submitted failed pdf content-type validation':
    'app.error.validation.failed.type.pdf',
  'bankCode BIC must be between 8 and 11 characters':
    'app.error.validation.failed.length.bic',
  preconditionFailed: 'app.error.preconditionFailed',
  preconditionFailedWrongIban: 'app.error.preconditionFailed.wrongIban',
  entityTooLarge: 'app.error.entityTooLarge',
};
